/* Publish by EComposer at 2026-10-17 04:31:54*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-glanwozb5dj"]=  window.__ectimmers["ecom-glanwozb5dj"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-glanwozb5dj"]["yflmitt7m"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-glanwozb5dj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-glanwozb5dj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vxmip7lmtcn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vxmip7lmtcn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gydhl6gktr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gydhl6gktr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k5ujt5l7lup').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k5ujt5l7lup', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5jfthm0ypen').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5jfthm0ypen', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7u2hu07e4sh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7u2hu07e4sh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-urotwdopg0r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-urotwdopg0r', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5t7xpyusxqv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5t7xpyusxqv', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}